type Status = 'pending' | 'approved' | 'rejected' | 'deleted' | 'confirmed' | 'shipped' | 'delivered' | 'cancelled';

const config: Record<Status, { label: string; className: string; icon: string }> = {
  pending: { label: 'En attente', className: 'bg-amber-100 text-amber-700 border-amber-200', icon: 'ri-time-line' },
  approved: { label: 'Approuvé', className: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: 'ri-checkbox-circle-line' },
  rejected: { label: 'Rejeté', className: 'bg-red-100 text-red-700 border-red-200', icon: 'ri-close-circle-line' },
  deleted: { label: 'Corbeille', className: 'bg-slate-100 text-slate-600 border-slate-200', icon: 'ri-delete-bin-line' },
  confirmed: { label: 'Confirmé', className: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: 'ri-checkbox-circle-line' },
  shipped: { label: 'Expédié', className: 'bg-blue-100 text-blue-700 border-blue-200', icon: 'ri-truck-line' },
  delivered: { label: 'Livré', className: 'bg-teal-100 text-teal-700 border-teal-200', icon: 'ri-checkbox-circle-fill' },
  cancelled: { label: 'Annulé', className: 'bg-gray-100 text-gray-600 border-gray-200', icon: 'ri-close-line' },
};

interface Props {
  status: Status;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'sm' }: Props) {
  const { label, className, icon } = config[status] ?? config.pending;
  const padding = size === 'md' ? 'px-3 py-1.5 text-sm' : 'px-2.5 py-1 text-xs';
  return (
    <span className={`inline-flex items-center gap-1.5 font-semibold rounded-full border whitespace-nowrap ${className} ${padding}`}>
      <i className={`${icon} text-[11px]`}></i>
      {label}
    </span>
  );
}
